import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class PopupPortal extends React.Component {
  render() {
    // Use a portal to render the children into the element

    return this.props.usePopupPortal
      ? ReactDOM.createPortal(
          // Any valid React child: JSX, strings, arrays, etc.
          this.props.children,
          // A DOM element
          document.querySelector(
            this.props.wrapper ? this.props.wrapper : '.popupWrapper',
          ),
        )
      : this.props.children;
  }
}
PopupPortal.propTypes = {
  usePopupPortal: PropTypes.bool,
};
PopupPortal.defaultProps = {
  usePopupPortal: false,
};

export default PopupPortal;
